<template>
  <div class="row">
    <div class="col-xl-6 col-lg-6">
      <edit-operator-dialog v-if="details" :show="showEdit" @close="showEdit=false" :form-details="editPayload"/>
      <card class="card-user">
        <template slot="header">
          <h4 class="card-title">{{ $t('operators.title') }}</h4>
        </template>
        <div class="author">
          <div class="block block-one"></div>
          <!--        <div class="block block-two"></div>-->
          <div class="block block-three"></div>
          <div class="block block-four"></div>
        </div>
        <div v-loading="loading" v-if="details">
          <operator-details :details="details"/>
          <div class="button-container mt-3">
            <div class="row">
              <div class="col-6" v-if="$auth.can({operator: 'update'}, 'permissions')">
                <el-tooltip :content="$t('operators.update.btnTooltip')"
                            effect="light"
                            :open-delay="300"
                            placement="bottom">
                  <base-button block type="info" class="btn pr-3 pl-2" @click.native="handleEdit()">
                    <i class="tim-icons icon-pencil pr-2"/> {{ $t('operators.update.btnLabel') }}
                  </base-button>
                </el-tooltip>
              </div>
              <div class="col-6" v-if="$auth.can({operator: 'delete'}, 'permissions')">
                <el-tooltip :content="$t('operators.delete.btnTooltip')"
                            effect="light"
                            :open-delay="300"
                            placement="bottom">
                  <base-button block type="danger" class="btn pr-3 pl-2" @click.native="handleDelete()">
                    <i class="tim-icons icon-simple-remove pr-2"/> {{ $t('operators.delete.btnLabel') }}
                  </base-button>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </card>
    </div>
    <div class="col-xl-6 col-lg-6">
      <operator-assignees />
    </div>
    <div class="col-12">
      <card>
        <operator-bot-clients-page :operator-id="$route.params.id"/>
      </card>
    </div>
  </div>
</template>
<script>

import {mapActions, mapState} from "vuex";
import swal from "sweetalert2";
import OperatorDetails from "src/components/Operator/OperatorDetails";
import EditOperatorDialog from "./EditOperatorDialog";
import OperatorAssignees from "./OperatorAssignees";
import OperatorBotClientsPage from "./OperatorBotClients.vue";


export default {
  name: 'operator-view',
  components: {
    OperatorDetails,
    EditOperatorDialog,
    OperatorAssignees,
    OperatorBotClientsPage
  },
  data() {
    return {
      showEdit: false,
      editPayload: {settings: {stop_prefix: ''}},
    }
  },
  computed: {
    ...mapState({
      loading: state => state.operator.updating,
      details: state => state.operator.instance,
      error: state => state.operator.error,
    }),
  },
  methods: {
    ...mapActions(['LoadOperator', 'DeleteOperator']),
    handleEdit() {
      this.editPayload = {
        id: this.details.id,
        name: this.details.name,
        status: this.details.status,
        type: this.details.type,
        fare_group_id: this.details.fare_group_id,
        settings: {
          stop_prefix: this.details.settings ? this.details.settings.stop_prefix : ''
        }
      };
      this.showEdit = true;
    },
    handleDelete() {
      swal({
        title: this.$t('operators.delete.text'),
        text: `'${this.details.id}' - '${this.details.name}'`,
        confirmButtonText: this.$t('operators.delete.actionBtnLabel'),
        cancelButtonText: this.$t('operators.delete.cancelBtnLabel'),
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.DeleteOperator(this.details.id).then(() => {
            if (this.error == null) {
              this.$notify({
                type: 'success',
                message: this.$t('operators.delete.deletedNotification', this.details),
                icon: 'tim-icons icon-alert-circle-exc'
              })
              this.$router.push({name: 'operators'});
            }
          })
        }
      });
    },
  },
  mounted() {
    this.LoadOperator(this.$route.params.id)
  },
};
</script>
